import axios from 'axios';

const url = process.env.VUE_APP_API_BASE_URL;

function list(params) {
  return axios.post(`${url}/user/my_data/all`, params).then((res) => {
    return res;
  });
}

function get(params) {
  const options = {
    headers: {
      Accept: 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    },
  };

  return axios
    .post(`${url}/user/my_data/get`, params, options)
    .then((res) => {
      //console.log(res);
      if (res.hasOwnProperty('data') && res.data.error) {
        let errorInfo = '';
        for (const [key, value] of Object.entries(res.data)) {
          errorInfo += `<br> ${key}: ${value} <br>`;
        }
        errorInfo += `<br> API LINK: ${url}/user/my_data/get <br>`;
        throw new Error(errorInfo);
      }
      return res;
    })
    .catch((err) => {
      throw new Error(err.stack);
    });
}

function add(params) {
  const options = {
    headers: {
      Accept: 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    },
  };

  return axios
    .post(`${url}/user/my_data/add`, params, options)
    .then((res) => {
      if (res.hasOwnProperty('data') && res.data.error) {
        let errorInfo = '';
        for (const [key, value] of Object.entries(res.data)) {
          errorInfo += `<br> ${key}: ${value} <br>`;
        }
        errorInfo += `<br> API LINK: ${url}/user/my_data/add <br>`;
        throw new Error(errorInfo);
      }
      return res;
    })
    .catch((err) => {
      throw new Error(err.stack);
    });
}

function csv(params) {
  const options = {
    headers: {
      Accept: 'application/vnd.api+json',
      'Content-Type': 'multipart/form-data',
    },
  };

  return axios
    .post(`${url}/user/my_data/csv`, params, options)
    .then((res) => {
      if (res.hasOwnProperty('data') && res.data.error) {
        let errorInfo = '';
        for (const [key, value] of Object.entries(res.data)) {
          errorInfo += `<br> ${key}: ${value} <br>`;
        }
        errorInfo += `<br> API LINK: ${url}/user/my_data/csv <br>`;
        throw new Error(errorInfo);
      }
      return res;
    })
    .catch((err) => {
      throw new Error(err.stack);
    });
}

function destroy(params) {
  const options = {
    headers: {
      Accept: 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    },
  };

  return axios
    .post(`${url}/user/my_data/delete`, params, options)
    .then((res) => {
      if (res.hasOwnProperty('data') && res.data.error) {
        let errorInfo = '';
        for (const [key, value] of Object.entries(res.data)) {
          errorInfo += `<br> ${key}: ${value} <br>`;
        }
        errorInfo += `<br> API LINK: ${url}/user/my_data/delete/ <br>`;
        throw new Error(errorInfo);
      }
      return res;
    })
    .catch((err) => {
      throw new Error(err.stack);
    });
}

export default {
  list,
  get,
  add,
  csv,
  destroy,
};
